import { hasPermissions } from 'dashboard/helper/permissionsHelper';
import {
  GOOGLE_CALENDAR_CONNECT_PERMISSIONS,
  GOOGLE_SHEETS_CONNECT_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

// Quem abre o quê em Configurações › Integrações (#586).
//
// A Google Agenda é do PRÓPRIO usuário: todo mundo logado abre a tela, inclusive a função
// personalizada sem `google_calendar_connect` — ela não conecta, mas precisa conseguir ver e
// desconectar a agenda que já tinha ligado. O Sheets é da CONTA: administrador ou quem tem
// `google_sheets_connect`. O resto das integrações continua só do administrador.
export const EVERY_USER_PERMISSIONS = ['administrator', 'agent', 'custom_role'];
export const GOOGLE_CALENDAR_ROUTE_PERMISSIONS = EVERY_USER_PERMISSIONS;
export const GOOGLE_SHEETS_ROUTE_PERMISSIONS = [
  'administrator',
  GOOGLE_SHEETS_CONNECT_PERMISSIONS,
];

const NON_ADMIN_INTEGRATIONS = {
  google_calendar: GOOGLE_CALENDAR_ROUTE_PERMISSIONS,
  google_sheets: GOOGLE_SHEETS_ROUTE_PERMISSIONS,
};

export const canOpenIntegration = (id, permissions = []) => {
  if (permissions.includes('administrator')) return true;
  const required = NON_ADMIN_INTEGRATIONS[id];
  return Boolean(required) && hasPermissions(required, permissions);
};

export const visibleIntegrations = (integrations = [], permissions = []) =>
  integrations.filter(item => canOpenIntegration(item.id, permissions));

// Espelha UserCalendarConnectionPolicy#connect?: o atendente sem função personalizada recebe
// `google_calendar_connect` pelo piso (PermissionCatalog::DEFAULT_VIEW_PERMISSIONS).
export const canConnectGoogleCalendar = (permissions = []) =>
  hasPermissions(
    ['administrator', GOOGLE_CALENDAR_CONNECT_PERMISSIONS],
    permissions
  );
